RivalIQ.module('regions', function (regions, App, Backbone, Marionette, $, _) {

    'use strict';

    regions.ListRegion = Marionette.Region.extend({

        initialize: function () {
            const me = this;
            me.currentViews = [];
        },

        attachHtml: function (view) {
            const me = this;
            me.currentViews.push(view);
            const wrapper = document.createElement('li');
            wrapper.appendChild(view.el);
            me.$el.append(wrapper);
        },
        empty: function (options) {
            const me = this;
            const views = me.currentViews;

            const emptyOptions = options || {};
            const preventDestroy = Boolean(emptyOptions.preventDestroy);

            if (!views.length || !me.currentView) { return me; }

            _.each(me.currentViews, function (view) {
                view.off('destroy', me.empty, me);
                me.triggerMethod('before:empty', view);
                if (!preventDestroy) {
                    me._destroyView(view);
                }
                me.triggerMethod('empty', view);

                if (preventDestroy) {
                    me.$el.contents().detach();
                }
            });

            me.currentViews = [];

            return me;
        },
        // // call 'destroy' or 'remove', depending on which is found
        // // on the view (if showing a raw Backbone view or a Marionette View)
        _destroyView: function (view) {
            if (view.isDestroyed) { return; }

            if (!view.supportsDestroyLifecycle) {
                Marionette.triggerMethodOn(view, 'before:destroy', view);
            }
            if (view.destroy) {
                view.destroy();
            } else {
                view.remove();

                // appending isDestroyed to raw Backbone View allows regions
                // to throw a ViewDestroyedError for this view
                view.isDestroyed = true;
            }
            if (!view.supportsDestroyLifecycle) {
                Marionette.triggerMethodOn(view, 'destroy', view);
            }
        }
    });
});
